export class LocationRequest{
    locationId?: number;
    constructor(locationId:number){
        this.locationId = locationId;
    }
}